import { render } from "./navigation.vue?vue&type=template&id=78b980a2"
import script from "./navigation.vue?vue&type=script&lang=js"
export * from "./navigation.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kevinschade/Code/bioeffect/New BIOEFFECt Wesbstie themes/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__